import React, { useContext } from "react";
import styled from "styled-components";
import { color, font } from "../templates/ui";
import { default as LogoutIcon } from "../atoms/icons/LogoutIcon";
import Dossier from "../atoms/icons/Dossier";
import { UserContext } from "../Context/UserContext";
import Logout from "./Logout";
import { getAppThemeName, } from "../../Services/appTheme";
import { useInFormation } from "../Context/InFormationContext";
const Header = styled.div `
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: 20px;

  @media only screen and (min-width: 768px) {
    flex-direction: row;
    align-items: flex-end;
    margin-bottom: 20px;
`;
const TitleContainer = styled.div `
    @media only screen and (max-width: 767px) {
        margin-bottom: 20px;
    }
`;
const RequestInformation = styled.div `
    display: flex;
    flex-direction: row-reverse;

    @media only screen and (max-width: 767px) {
        background-color: ${(props) => props.appTheme === "invoned" ? "transparent" : color.body.base};
        box-shadow: ${(props) => props.appTheme === "invoned"
    ? "none"
    : "0 0 20px rgba(26, 26, 33, 0.11)"};
        width: 100%;
        padding: ${(props) => props.appTheme === "invoned" ? "20px 20px 20px 0" : "20px"};
        border-radius: 10px;
        justify-content: space-between;
    }

    @media only screen and (min-width: 768px) {
        flex-direction: column;
        text-align: right;
    }
`;
const Title = styled.h1 `
    color: ${(props) => props.appTheme === "invoned" ? "white" : props.theme.tertiary};
    font-size: ${font.xxxxlarge};
`;
const SubTitle = styled.h3 `
    color: ${(props) => props.appTheme === "invoned" ? "white" : props.theme.tertiary};
    font-size: ${font.large};
    font-weight: 400;
`;
const StyledLogoutWrapper = styled.div `
    @media only screen and (min-width: 768px) {
        margin-bottom: 5px;
    }
`;
const StyledLogoutButton = styled(Logout) `
    transition: all ease 0.2s;
    background-color: ${(props) => props.appTheme === "invoned" ? "transparent" : props.theme.tertiary};
    border-radius: 5px;
    padding: 6px;

    &:hover,
    &:focus {
        background-color: ${color.error.base};
        transform: scale(1.04);
    }

    svg {
        fill: ${color.body.base};
        width: 17px;
        height: 17px;
        vertical-align: middle;
    }
`;
const StyledDossierInfo = styled.div `
    vertical-align: middle;
`;
const StyledDossierIcon = styled(Dossier) `
    fill: ${(props) => props.theme.primary};
    vertical-align: middle;
    margin-right: 6px;
    width: 21px;
    height: 18px;
`;
const StyledDossierText = styled.span `
    color: ${(props) => props.appTheme === "invoned" ? "white" : props.theme.tertiary};
    vertical-align: middle;
`;
const FormHeader = () => {
    const { user } = useContext(UserContext);
    const { inFormation } = useInFormation();
    return (React.createElement(Header, null,
        React.createElement(TitleContainer, null,
            React.createElement(Title, { appTheme: getAppThemeName() }, "Informatieverzoek"),
            React.createElement(SubTitle, { appTheme: getAppThemeName() }, inFormation.title)),
        user && (React.createElement(RequestInformation, { appTheme: getAppThemeName() },
            React.createElement(StyledLogoutWrapper, null,
                React.createElement(StyledLogoutButton, { appTheme: getAppThemeName() },
                    React.createElement(LogoutIcon, null))),
            React.createElement(StyledDossierInfo, null,
                React.createElement(StyledDossierIcon, null),
                React.createElement(StyledDossierText, { appTheme: getAppThemeName() },
                    React.createElement("strong", null, "Dossier nr."),
                    " ",
                    user.doswerk_dossier))))));
};
export default FormHeader;
